import React from "react";
import colors from "../constants/colors";

export interface ValueDisplayProps {
	label: string;
	node: React.ReactNode;
	row?: boolean;
}

export const ValueDisplay = (props: ValueDisplayProps) => {
	const display = props.row ? "inline" : "block";

	return (
		<span data-testid="value-display">
			<div
				style={{
					display,
					textTransform: "uppercase",
					fontSize: 11,
					fontWeight: 600,
					letterSpacing: ".1em",
					marginRight: 4,
					color: colors.gray600,
				}}
				data-testid="value-display-label"
			>
				{props.label}:
			</div>
			<div style={{ display }} data-testid="value-display-node">
				{props.node}
			</div>
		</span>
	);
};
